import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/about.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/links.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/website-popup/Form.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Cards.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Carousel.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NewCards.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RescoCount.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Tabs.jsx");
